import { Action, createReducer, on } from '@ngrx/store';
import { OmsAction } from '../actions/oms.action';
import { EasyState, IBaseOrderEntity, OMSOrder } from '../../../modules/order';
import { OmsState } from '../../app.state';
import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { getOrderInstance, updateState } from './order.factory';
import { deleteProperties } from '../../../tools/primptives-tool/object-tool';

// export function sortByName(a: IBaseOrderEntity, b: IBaseOrderEntity): number {
// 	return a.symbolName.localeCompare(b.symbolName);
// }
// export function selectOrders(orderModelTye: OrderModelType, state: OmsState): IBaseOrderEntity[] {
// 	//In this case this would be optional since primary key is id
// 	return Object.values(state.entities).filter(t => t.orderModelType !== orderModelTye);
// }
const exceptedOmsProps = ['executedQuantity', 'minimumQuantity', 'marketType', 'iceberg', 'triggerPrice'];
export const omsAdapter: EntityAdapter<IBaseOrderEntity> = createEntityAdapter<IBaseOrderEntity>();

const initialState: OmsState = omsAdapter.getInitialState({
	loading: false
});

export function omsReducer(state: any, action: Action) {
	return _orderReducer(state, action);
}
const _orderReducer = createReducer(
	initialState,
	on(OmsAction.load, state => ({ ...state, loading: true })),
	on(OmsAction.loaded, state => ({ ...state, loading: false })),
	on(OmsAction.loadedError, state => ({ ...state, loading: false })),
	on(OmsAction.set, (state, { value }) => {
		const newOrders = value.orders.map(
			t => new OMSOrder({ ...deleteProperties(t, exceptedOmsProps), easyState: EasyState.Done })
		);
		const newState = omsAdapter.setAll(newOrders, state);
		return { ...newState, loading: false, algoSuffixCharacters: value.algoSuffixCharacters };
	}),
	on(OmsAction.updateMany, (state, { ids, changes }) => {
		const orders = Object.values(state.entities).filter(t => ids.includes(t.id));
		const newState = omsAdapter.removeMany(ids as string[], state);
		const newOrders = orders.map(order => getOrderInstance({ ...order, ...changes } as IBaseOrderEntity));

		return omsAdapter.addMany(newOrders, newState);
	}),

	on(OmsAction.updateOrderPlaces, (state, { values }) => {
		const ids = values.map(value => value.orderId);
		const orders = Object.values(state.entities)?.filter(t => ids.includes(t.id));
		const newState = omsAdapter.removeMany(ids as string[], state);
		const newOrders = orders.map(order => {
			const change = values.find(t => t.orderId === order.id);
			return getOrderInstance({ ...order, ...change } as IBaseOrderEntity);
		});

		return omsAdapter.addMany(newOrders, newState);
	}),
	on(OmsAction.update, (state, { id, changes }) => {
		return updateState(omsAdapter, { id: id as string, changes }, state);
	}),
	on(OmsAction.add, (state, { value }) => {
		const index = Object.values(state.entities)?.findIndex(t => t.id === value.id);
		if (index < 0) return omsAdapter.addOne(getOrderInstance(value), state);
		return updateState(omsAdapter, { id: value?.id as string, changes: value }, state);
	}),
	on(OmsAction.delete, (state, { id: orderId }) => {
		return omsAdapter.removeOne(orderId as string, state);
	}),
	on(OmsAction.delete, (state, { id: orderId }) => {
		return omsAdapter.removeOne(orderId as string, state);
	}),
	on(OmsAction.deleteMany, (state, { ids: orderIds }) => {
		return omsAdapter.removeMany(orderIds, state);
	}),

	on(OmsAction.createOms, (state, { newOrder }) => {
		return omsAdapter.addOne(getOrderInstance(newOrder), state);
	}),
	on(OmsAction.createdOms, (state, { value }) => {
		// value.changes.id==response.id
		const index = Object.values(state.entities)?.findIndex(t => t.id === value.changes.id);
		// هنوز نیومده بود ls اگر پاسخ
		if (index < 0) return updateState(omsAdapter, value, state);
		//ساخنه شده بود، حذف میشه guid زودتر اومده بود، فقط رکوردی که با  ls اگر پاسخ
		//value.id==guid
		const newState = omsAdapter.removeOne(value.id as string, state);
		return newState;
	}),
	on(OmsAction.updatedOms, (state, { value }) => {
		// value.id==response.id
		const index = Object.values(state.entities)?.findIndex(t => t.id === value.id);
		// هنوز نیومده بود ls اگر پاسخ
		if (index < 0) return omsAdapter.addOne(getOrderInstance(value), state);

		//زودتر اومده بود، کاری انجام نشه ls اگر پاسخ
		return state;
	}),
	on(OmsAction.deleteOms, (state, { id }) => {
		const order = Object.values(state.entities)?.find(t => t.id === id);
		if (!order) return state;
		if (order.IsInErrorState) return omsAdapter.removeOne(id, state);
		return updateState(omsAdapter, { id, changes: { easyState: EasyState.InDeleteQueue } }, state);
	})
);
export const AllOmsOrder = omsAdapter.getSelectors().selectAll;
export const AllOmsOrserEntities = omsAdapter.getSelectors().selectEntities;
